import GuideConfirmation from './GuideConfirmation';

export default GuideConfirmation;
